import { Button } from "antd";
import styled from "styled-components";
import { COLORS } from "../../components/layout/theme";

export const Inner = styled.div`
	display: flex;
	min-height: 500px;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	padding: 30px 10px;
	gap: 40px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: center;
	align-items: center;
	background-color: ${COLORS.White};
	border-radius: 10px;
	min-height: 300px;
	gap: 20px;
`;

export const Section = styled.div`
	display: flex;
	width: 100%;
	gap: 20px;
	justify-content: space-between;
	align-items: center;
`;

export const AntdButton = styled(Button)`
	border-radius: 10px;
	padding: 20px 20px;
	display: flex;
	flex-direction: column;
	min-width: 100px;
`;

export const MessageContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	background: linear-gradient(135deg, #f6ffed 0%, #ffffff 100%);
	border-radius: 12px;
	padding: 32px 24px;
	margin-bottom: 24px;
	box-shadow: 0 4px 12px rgba(82, 196, 26, 0.1);
	border: 1px solid rgba(82, 196, 26, 0.2);
`;

export const AgentInfo = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	background: linear-gradient(135deg, #e6f7ff 0%, #ffffff 100%);
	border-radius: 12px;
	padding: 24px;
	margin-bottom: 24px;
	box-shadow: 0 2px 8px rgba(24, 144, 255, 0.1);
	border: 1px solid rgba(24, 144, 255, 0.2);
	max-width: 500px;
`;
